import {
  __HttpRequestModel__,
} from 'shared/domain/httpRequest/httpRequestModel';
import type { WorkflowDecisionOutDto } from 'shared/domain/workflow/types';
import {
  IDecisionUploader,
  UploadDecision,
} from 'serviceWorker/repository/workflow/uploadDecision';
import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import type { DecisionCreateRequestModel } from 'serviceWorker/services/workflows/createDecision';

export class DecisionRequestRunner implements IHttpRequestRunner {
  constructor(
    private decisionUploader: IDecisionUploader,
    private uploadDecisionUseCase: UploadDecision
  ) {}

  async execute(
    request: __HttpRequestModel__ | DecisionCreateRequestModel
  ): Promise<WorkflowDecisionOutDto> {
    switch (request.method) {
      case 'POST': {
        return this.uploadDecision(request as DecisionCreateRequestModel);
      }
      default: {
        throw new Error(`Unsupported method for decision: ${request.method}`);
      }
    }
  }

  private async uploadDecision(
    request: DecisionCreateRequestModel
  ): Promise<WorkflowDecisionOutDto> {
    return this.uploadDecisionUseCase(
      this.decisionUploader,
      request.data.decisionDto,
      request.url
    );
  }
}
